import { ArrowBackOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';
import { ReactElement } from 'react';
import { tokens } from '@synergy/theme-palo';

export interface PaloBackButtonProps {
    onClick: () => void;
}

/**
 * The back affordance of both PALO shells: a bordered square left of the title,
 * per the prototype's detail header. The list shells used to put their own one
 * behind the title, where it read as an action rather than a way out.
 */
export const PaloBackButton = ({ onClick }: PaloBackButtonProps): ReactElement => (
    <Box
        role="button"
        aria-label="Zurück"
        onClick={onClick}
        sx={{
            width: 28,
            height: 28,
            flexShrink: 0,
            border: `1px solid ${tokens.color.lineHard}`,
            borderRadius: tokens.radius.small + 'px',
            backgroundColor: tokens.color.surface,
            display: 'grid',
            placeItems: 'center',
            cursor: 'pointer',
            color: tokens.color.ink2,
            '&:hover': { backgroundColor: tokens.color.surfaceAlt },
            '& svg': { fontSize: 17 },
        }}
    >
        <ArrowBackOutlined />
    </Box>
);
